import { useState } from 'react';
import { LinearProgress } from '@mui/material';

type Props = {
  url: string;
  title: string;
  id: string;
  height?: string;
  width?: string;
  positionLeft?: string;
};

const EmbeddedIFrame = ({ url, title, id, height = '100%', width = '100%', positionLeft = '0' }: Props) => {
  const [loaded] = useState(false);

  return (
    <>
      <LinearProgress
        data-testid={'progressbar'}
        id={`${id}-progressbar`}
        hidden={loaded}
        color="primary"
        style={{ width: '100%' }}
      />
      <iframe
        style={{
          position: 'fixed',
          left: positionLeft,
          right: 0,
          top: 0,
          width: width,
          height: height,
        }}
        src={url}
        title={title}
        frameBorder="no"
        // onLoadCapture={() => {
        //   setLoaded(true);
        // }}
        // onLoad={() => {
        //   setLoaded(true);
        // }}
        id={id}
        allowFullScreen={true}
      />
    </>
  );
};

export default EmbeddedIFrame;
